module.exports = __webpack_public_path__ + "img/ge.8374b1d0.svg";